import { URLS } from 'services/urls';
import SignUpForm from './SignUpForm/SignUpForm';

export const SignUpSection = () => (
    <div className="DirectSignUp__SignUpSection">
        <div className="DirectSignUp__LogoWrapper">
            <img
                src={URLS.IMAGE_CLOUDFRONT_URL('NSLogo_Stacked.png')}
                alt="Northspyre Logo"
                className="DirectSignUp__Logo"
            />
        </div>
        <div className="DirectSignUp__CenteredContent">
            <SignUpForm />
        </div>
    </div>
);

export default SignUpSection;
